import {
  Box,
  Button,
  Grid,
  MenuItem,
  Select,
  SelectChangeEvent,
  Stack,
  TextareaAutosize,
  TextField,
  Typography,
} from '@mui/material'
import { ChangeEvent, useCallback, useState } from 'react'
import { IQuestionV2, MainObject } from '../../store/reports/types'
import FormLayout from '../forms/FormLayout'
import { PhotoCamera } from '@mui/icons-material'
import AddIcon from '@mui/icons-material/Add'
import colors from '../../constants/colors'
import ModalTAG from '../ModalTAG'
import CardTAG from '../CardTAG'
import TextInput from '../TextInput'
import { useForm } from 'react-hook-form'
import { vestResolver } from '@hookform/resolvers/vest'
import utils from '../forms/ReportingPartyForm/utils'
import selectOptions from '../../constants/selectOptions'
import LabelErrorTAG from '../LabelErrorTAG'

import { ReactComponent as ArrowIcon } from '../../assets/images/arrowIcon.svg'
import { selectStyle, textAreaStyle } from '../../constants/styleConstants'
import {
  addCustomFields,
  setReporterValues,
  updateCustomField,
} from '../../store/questions/questionsSlice'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch } from '../../store'
import questionsSelector from '../../store/questions/questionsSelector'
import { findItemByUuid } from '../../store/reports/reportsSlice'

// const imageUploadRowStyle = {
//   height: '100%',
//   justifyContent: 'space-between',
//   alignItems: 'center',
//   minHeight: '30vh',
//   maxHeight: '30vh',
//   width: '30vh',
// }
//
// const imageMessageStyle = {
//   display: 'flex',
//   justifyContent: 'center',
//   alignItems: 'center',
//   width: '100%',
//   height: '100%',
//   border: '1px solid #ccc',
//   borderRadius: '10px',
// }

interface IReporterFormQuestion {
  question: IQuestionV2
  answers?: MainObject[]

  victimQuestionId?: number | null
}

const ReporterFormQuestion: React.FC<IReporterFormQuestion> = ({
  question,
  answers,
  victimQuestionId = null,
}) => {
  // const getAnswer = () => {
  //   if (victimQuestionId) {
  //     return useSelector(questionsSelector.getVictimAnswer(victimQuestionId, question?.uuid))
  //   }
  //   if (answers && answers?.length > 0) {
  //     return findItemByUuid(answers, question?.uuid)
  //   }
  //   return useSelector(questionsSelector.answerToNewCaseQuestion(question?.uuid))
  // }
  // const answer = getAnswer()
  // const [imagePreview, setImagePreview] = useState<string | null>(null)
  const [openModal, setOpenModal] = useState<boolean>(false)

  const reporterData = useSelector(questionsSelector.newCaseReporter)
  const custom_fields = useSelector(questionsSelector.customFieldsSelector)

  const dispatch = useDispatch<AppDispatch>()

  const addNewTagFormMethods = useForm<any>({
    defaultValues: { newTag: '' },
    mode: 'onChange',
    shouldFocusError: false,
    resolver: vestResolver(utils.newTagFormValidation),
  })
  const {
    register: newTagRegister,
    handleSubmit: newTagHandleSubmit,
    formState: formStateNewTag,
    reset: resetNewTag,
  } = addNewTagFormMethods

  // const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
  //   if (e?.target?.files) {
  //     const file = e?.target?.files[0]
  //     file.arrayBuffer().then(arrayBuffer => {
  //       const blob = new Blob([new Uint8Array(arrayBuffer)], { type: file.type })
  //       dispatch(setReporterValues({ field: e.target.name, value: blob }))
  //     })
  //     setImagePreview(URL.createObjectURL(file))
  //   }
  // }

  // const customFieldOnChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
  //   dispatch(updateCustomField({ title: e.target.name, value: e.target?.value }))
  // }

  // const renderCustomFields = () => {
  //   return (
  //     custom_fields &&
  //     custom_fields.map((field, index) => {
  //       return (
  //         <Box sx={{ width: '100%' }} key={`${field?.title}-${index}`}>
  //           <LabelErrorTAG label={field.title} />
  //           <TextareaAutosize
  //             name={field.title}
  //             key={field.title}
  //             value={field?.description}
  //             style={textAreaStyle}
  //             minRows={5}
  //             placeholder={''}
  //             onChange={customFieldOnChange}
  //           />
  //         </Box>
  //       )
  //     })
  //   )
  // }
  //
  // const openModalHandler = () => {
  //   setOpenModal(true)
  // }

  const addNewTagSubmitHandler = (values: { newTag: string }) => {
    const { newTag } = values

    dispatch(
      addCustomFields({
        custom_fields: [
          ...custom_fields,
          {
            title: newTag,
            description: '',
          },
        ],
      }),
    )
    resetNewTag({ newTag: '' })
    setOpenModal(false)
  }

  const getMessageNewTag = useCallback(
    (field: 'newTag') => {
      if (!formStateNewTag.errors[field]) return ''

      return formStateNewTag.errors[field]!.message
    },
    [formStateNewTag],
  )

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(setReporterValues({ field: e.target.name, value: e.target.value }))
  }

  const onChangeHandler = (e: SelectChangeEvent) => {
    dispatch(setReporterValues({ field: e.target.name, value: e.target.value }))
  }

  return (
    <>
      <Box className={'t-vbox t-gap-18'}>
        {/*<Grid item xs={12} sm={4}>*/}
        {/*  <Stack sx={imageUploadRowStyle}>*/}
        {/*    {!imagePreview && (*/}
        {/*      <Box sx={imageMessageStyle}>*/}
        {/*        <Typography sx={{ textAlign: 'center' }}>Upload Profile Image</Typography>*/}
        {/*      </Box>*/}
        {/*    )}*/}
        {/*    {imagePreview && (*/}
        {/*      <Box sx={{ width: { xs: '100%' }, height: { xs: '100%' } }}>*/}
        {/*        <img*/}
        {/*          style={{ width: '100%', height: '100%', objectFit: 'contain' }}*/}
        {/*          src={imagePreview}*/}
        {/*        />*/}
        {/*      </Box>*/}
        {/*    )}*/}
        {/*    <Button*/}
        {/*      variant='submitFormButton'*/}
        {/*      component='label'*/}
        {/*      sx={{ mt: '18px' }}*/}
        {/*      endIcon={<PhotoCamera />}*/}
        {/*    >*/}
        {/*      <Typography variant='bodyBold'>*/}
        {/*        {imagePreview ? 'Change Image' : 'Upload Image'}*/}
        {/*      </Typography>*/}
        {/*      <input*/}
        {/*        onChange={handleFileChange}*/}
        {/*        hidden*/}
        {/*        multiple*/}
        {/*        accept='image/*'*/}
        {/*        type='file'*/}
        {/*        id='image'*/}
        {/*        name='image'*/}
        {/*      />*/}
        {/*    </Button>*/}
        {/*  </Stack>*/}
        {/*</Grid>*/}
        <FormLayout>
          <Stack>
            <LabelErrorTAG label='Full Name' />
            <TextField
              value={reporterData?.full_name}
              onChange={onChange}
              variant='standard'
              type={'text'}
              fullWidth
              id='full_name'
              name='full_name'
            />
          </Stack>
          <Stack>
            <span
              style={{ marginBottom: '.7rem' }}
              className='t-font-bold t-font-size-xxs t-color-black'
            >
              The initial reporting party’s relationship to the company
            </span>
            <Select
              onChange={onChangeHandler}
              value={reporterData?.person_type as string}
              IconComponent={ArrowIcon}
              displayEmpty
              sx={[selectStyle]}
              id='person_type'
              name='person_type'
            >
              {selectOptions.subjectTypes.map(option => {
                if (!['UNKNOWN'].includes(option.value)) {
                  return (
                    <MenuItem value={option?.value} key={option?.value}>
                      <Typography variant='bodyBold'>{option?.label}</Typography>
                    </MenuItem>
                  )
                }
              })}
            </Select>
          </Stack>
          <Stack>
            <LabelErrorTAG label='Phone Number' />
            <TextField
              value={reporterData?.phone_number}
              onChange={onChange}
              variant='standard'
              type={'text'}
              fullWidth
              id='phone_number'
              name='phone_number'
            />
          </Stack>
          <Stack>
            <LabelErrorTAG label='Email Address' />
            <TextField
              value={reporterData?.email}
              onChange={onChange}
              variant='standard'
              type={'email'}
              fullWidth
              id='email'
              name='email'
            />
          </Stack>
          <Stack>
            <LabelErrorTAG label='Work Site' />
            <TextField
              value={reporterData?.work_site}
              onChange={onChange}
              variant='standard'
              type={'text'}
              fullWidth
              id='work_site'
              name='work_site'
            />
          </Stack>
          <Stack>
            <LabelErrorTAG label='Work City' />
            <TextField
              value={reporterData?.city}
              onChange={onChange}
              variant='standard'
              type={'text'}
              fullWidth
              id='city'
              name='city'
            />
          </Stack>
          <Stack>
            <LabelErrorTAG label='Work Country' />
            <TextField
              value={reporterData?.work_country}
              onChange={onChange}
              variant='standard'
              type={'text'}
              fullWidth
              id='work_country'
              name='work_country'
            />
          </Stack>

          {/*{renderCustomFields()}*/}
          {/*<Button*/}
          {/*  variant='outlined'*/}
          {/*  startIcon={<AddIcon />}*/}
          {/*  sx={{ color: colors.BLACK }}*/}
          {/*  onClick={openModalHandler}*/}
          {/*>*/}
          {/*  <Typography variant='bodyRegular' color='inherit'>*/}
          {/*    Add Custom Text Field*/}
          {/*  </Typography>*/}
          {/*</Button>*/}
        </FormLayout>
      </Box>
      <ModalTAG open={openModal}>
        <form onSubmit={newTagHandleSubmit(addNewTagSubmitHandler)}>
          <CardTAG
            title={'Add Custom Field Title'}
            closable={true}
            closeCard={() => {
              setOpenModal(false)
            }}
          >
            <FormLayout>
              <TextInput
                register={newTagRegister}
                fieldName={'newTag'}
                label={'Title'}
                error={getMessageNewTag('newTag') as string}
              />
              <Button variant='submitFormButton' type='submit'>
                <Typography variant='bodyBold'>Add</Typography>
              </Button>
            </FormLayout>
          </CardTAG>
        </form>
      </ModalTAG>
    </>
  )
}

export default ReporterFormQuestion
